/* ds-wishlist-page.js — рендер страницы избранного.
 *
 * Список даёт ds-wishlist.js (window.DsWishlist). Карточки не собираются в
 * JS: для каждого handle запрашивается /products/<handle>?view=card —
 * серверный alternate view с готовым product-card-states. 404 означает, что
 * товар удалён из магазина: хендл молча вычищается из хранилища.
 * В наличии — сначала; распроданные — после. Пилюля alerts фильтрует подписки.
 * Ключевые контейнеры удерживают порядок при асинхронной загрузке карточек.
 *
 * Страница живая в обе стороны: снятие сердечка убирает карточку, а
 * добавление в избранное прямо с этой страницы (сердечки «Топ продаж»,
 * карусели) подгружает карточку в начало сетки. Новые карточки
 * инициализируются (ProductCardPremium/DsWishlist) на отсоединённом
 * контейнере ДО вставки — повторный init уже живых карточек продублировал
 * бы их обработчики.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var page = document.querySelector('[data-ds-wishlist-page]');
    if (!page || !window.DsWishlist) return;

    var grid = page.querySelector('[data-ds-wishlist-grid]');
    var empty = page.querySelector('[data-ds-wishlist-empty]');
    var status = page.querySelector('[data-ds-wishlist-status]');
    var loginHint = page.querySelector('[data-ds-wishlist-login-hint]');
    var viewName = page.getAttribute('data-card-view') || 'card';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var failures = 0;
    var selectedFilter = 'all';
    var alertsEmpty = page.querySelector('[data-ds-wishlist-alerts-empty]');
    function arrange() {
      var alerts = new Set((window.AmiteaBIS ? window.AmiteaBIS.list() : []).map(function (item) { return String(item.productId); }));
      var ordered = combinedItems().map(function (item) { return entries.get(String(item.id)); }).filter(Boolean);
      ordered.sort(function (a, b) {
        function unavailable(slot) {
          var product = slot.querySelector('[data-product-card-available]');
          return product && product.dataset.productCardAvailable === 'false' ? 1 : 0;
        }
        return unavailable(a) - unavailable(b);
      });
      var visible = 0;
      ordered.forEach(function (slot, index) {
        slot.hidden = selectedFilter === 'alerts' && !alerts.has(slot.dataset.wishlistId);
        if (!slot.hidden) visible++;
        if (grid.children[index] !== slot) grid.insertBefore(slot, grid.children[index] || null);
      });
      page.querySelectorAll('[data-ds-wishlist-filter]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.dsWishlistFilter === selectedFilter));
      });
      if (alertsEmpty) alertsEmpty.hidden = selectedFilter !== 'alerts' || visible > 0;
      if (selectedFilter === 'alerts') { empty.hidden = true; grid.hidden = visible === 0; }
      else if (ordered.length) showGrid();
      else showEmpty();
    }
    page.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ds-wishlist-filter]');
      if (!button) return;
      selectedFilter = button.dataset.dsWishlistFilter; arrange();
    });

    function setStatus(text) {
      if (!status) return;
      if (text) {
        status.textContent = text;
        status.removeAttribute('hidden');
      } else {
        status.setAttribute('hidden', '');
      }
    }

    function showEmpty() {
      grid.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
      setStatus('');
      if (loginHint) loginHint.setAttribute('hidden', '');
    }

    function showGrid() {
      empty.setAttribute('hidden', '');
      grid.removeAttribute('hidden');
      if (loginHint) loginHint.removeAttribute('hidden');
    }

    function isSetItem(item) {
      return item.type === 'set' || String(item.id).indexOf('set:') === 0;
    }

    /* Подборка — метаобъект, /products/<handle> для неё не существует.
       Карточка клонируется из скрытого шаблона, пререндеренного секцией.
       Нет шаблона — сет удалён из магазина, запись вычищается (зеркально
       404-ветке товаров). */
    function placeSetCard(item, slot, initLocal) {
      var tpl = page.querySelector('[data-ds-wishlist-set-template][data-set-id="' + CSS.escape(String(item.id)) + '"]') ||
        page.querySelector('[data-ds-wishlist-set-template][data-set-handle="' + CSS.escape(String(item.handle)) + '"]');
      if (!tpl) {
        window.DsWishlist.remove(item.id);
        slot.remove();
        return Promise.resolve();
      }
      var holder = document.createElement('div');
      holder.appendChild(tpl.content.cloneNode(true));
      if (initLocal) {
        window.DsWishlist.init(holder);
        // Лупа сета (quick view подборки) на инкрементально добавленной
        // карточке: биндим триггеры до вставки, как у товарных карточек.
        if (window.ProductCardPremium) window.ProductCardPremium.init(holder);
      }
      var fragment = document.createDocumentFragment();
      while (holder.firstChild) fragment.appendChild(holder.firstChild);
      slot.replaceChildren(fragment);
      slot.className = 'ds-wishlist-page__entry';
      if (window.AmiteaBIS) window.AmiteaBIS.init(slot);
      return Promise.resolve();
    }

    /* initLocal: инициализировать карточку до вставки в DOM (для
       инкрементальных добавлений; листенеры переезжают вместе с узлами). */
    function fetchCard(item, slot, initLocal) {
      if (isSetItem(item)) return placeSetCard(item, slot, initLocal);
      var url = root + 'products/' + encodeURIComponent(item.handle) + '?view=' + viewName;
      return fetch(url)
        .then(function (response) {
          if (response.status === 404) {
            window.DsWishlist.remove(item.id);
            if (!window.AmiteaBIS || !window.AmiteaBIS.unavailableCard(slot, String(item.id))) slot.remove();
            return null;
          }
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (html === null) return;
          var holder = document.createElement('div');
          holder.innerHTML = html;
          if (initLocal) {
            if (window.ProductCardPremium) window.ProductCardPremium.init(holder);
            window.DsWishlist.init(holder);
          }
          var fragment = document.createDocumentFragment();
          while (holder.firstChild) fragment.appendChild(holder.firstChild);
          slot.replaceChildren(fragment);
          slot.className = 'ds-wishlist-page__entry';
          if (window.AmiteaBIS) window.AmiteaBIS.init(slot);
        })
        .catch(function () {
          /* Сеть/5xx: карточку не рисуем, но товар из избранного не выкидываем. */
          failures += 1;
          if (!window.AmiteaBIS || !window.AmiteaBIS.unavailableCard(slot, String(item.id))) slot.remove();
        });
    }

    function makeSlot() {
      var slot = document.createElement('div');
      slot.className = 'ds-wishlist-page__skeleton';
      return slot;
    }

    // A keyed slot owns each in-flight fetch. Late responses cannot duplicate or
    // reorder items after a subscription change; existing cards keep handlers/focus.
    var entries = new Map();
    var pendingLoads = 0;
    function combinedItems() {
      var waiting = window.AmiteaBIS ? window.AmiteaBIS.list().slice() : [];
      waiting.sort(function (a, b) { return b.createdAt - a.createdAt; });
      var seen = new Set();
      return waiting.map(function (item) {
        return { id: item.productId, handle: item.handle };
      }).concat(window.DsWishlist.list()).filter(function (item) {
        if (seen.has(String(item.id))) return false;
        seen.add(String(item.id)); return true;
      });
    }
    function reconcile() {
      var items = combinedItems();
      var wanted = new Set(items.map(function (item) { return String(item.id); }));
      entries.forEach(function (entry, id) {
        if (!wanted.has(id)) { entry.remove(); entries.delete(id); }
      });
      if (!items.length) { arrange(); return; }
      showGrid();
      items.forEach(function (item) {
        var id = String(item.id);
        var slot = entries.get(id);
        if (!slot) {
          slot = makeSlot(); slot.dataset.wishlistId = id; entries.set(id, slot);
          grid.appendChild(slot);
          pendingLoads += 1;
          fetchCard(item, slot, true).then(function () {
            pendingLoads -= 1;
            if (!slot.isConnected && entries.get(id) === slot) entries.delete(id);
            if (failures) setStatus(page.getAttribute('data-error-text'));
            if (!grid.children.length && !combinedItems().length) showEmpty();
            arrange();
            if (!pendingLoads && window.ProductCardPremium) window.ProductCardPremium.refreshCart();
          });
        }
      });
      arrange();
    }
    document.addEventListener('ds:wishlist:change', reconcile);
    document.addEventListener('ds:bis:change', reconcile);
    reconcile();
  });
})();
